"use client";

import { Center, Stack, Text, Button, Container, Title, Paper } from '@mantine/core';
import { useRouter } from 'next/navigation';
import { IconHome, IconArrowLeft } from '@tabler/icons-react';

export default function NotFound() {
  const router = useRouter();

  return (
    <Container w={{ base: "100%", sm: 500 }} m={{ base: 10, sm: 40 }} mx="auto">
      <Center>
        <Stack align="center" gap="xl" ta="center">
          {/* 404 Number */}
          <Text 
            size="6rem" 
            fw={900} 
            variant="gradient" 
            gradient={{ from: 'blue', to: 'cyan', deg: 45 }}
            style={{ lineHeight: 1 }}
          >
            404
          </Text>
          
          {/* Error Message */}
          <Stack gap="md">
            <Title order={2} size="h3">
              Page Not Found
            </Title>
            <Text color="dimmed" size="sm" ta="center" maw={400}>
              Sorry, we couldn&apos;t find the page you&apos;re looking for. It might have been moved, deleted, or you entered the wrong URL.
            </Text>
          </Stack>
          
          {/* Action Buttons */}
          <Paper 
            style={{ 
              background: 'transparent',
              border: 'none',
              boxShadow: 'none',
              padding: 0,
              width: '100%',
              maxWidth: 300
            }}
          >
            <Stack gap="md">
              <Button 
                fullWidth 
                onClick={() => router.push('/dashboard')}
                leftSection={<IconHome size={20} />}
              >
                Go to Dashboard
              </Button>
              
              <Button 
                variant="light" 
                fullWidth
                leftSection={<IconArrowLeft size={20} />}
                onClick={() => router.back()}
              >
                Go Back
              </Button>
            </Stack>
          </Paper>
        </Stack>
      </Center>
    </Container>
  );
} 